import React from "react";
import { bool, object, string } from "prop-types";
import { clamp } from "lodash";

import NewsWithImage from "../../../molecules/NewsWithImage";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";
import ComponentContainer from "../../../layouts/component-container";
import { componentProps } from "../../../utils/utils";

import "./doubleCollection.m.css";

const DoubleCollections = ({ collection, theme, hideSubHeadline }) => {
  const { items = [], numberOfStoriesShow } = componentProps(collection);

  const stories = items.filter(({ type }) => type === "story").slice(0, clamp(numberOfStoriesShow, 4));

  if (!stories.length) {
    return null;
  }

  const [firstStory, ...restStory] = stories;

  return (
    <ComponentContainer
      styleName="base"
      className={theme}
      collection={collection}
      isBanner={true}
      childContainer={true}
    >
      <div styleName="storyWrapper">
        <NewsWithImage
          showSubHeading={!hideSubHeadline}
          story={firstStory.story}
          showExcerpt={true}
          widths={[375, 242, 396]}
        />

        <div styleName="rest-items">
          {restStory.map(({ story }, index) => (
            <LeftImageRightNews
              showSubHeading={!hideSubHeadline}
              key={index}
              story={story}
              imageType="image1x1"
              aspectRatio={[1, 1]}
              widths={[155, 110, 186]}
            />
          ))}
        </div>
      </div>
    </ComponentContainer>
  );
};

DoubleCollections.propTypes = {
  collection: object.isRequired,
  theme: string,
  hideSubHeadline: bool,
};

export default DoubleCollections;
